import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';

/**
 * Returns a goBack function that uses browser history when available,
 * or falls back to the provided fallback route.
 */
export function useGoBack(fallbackRoute: string) {
  const navigate = useNavigate();

  return useCallback(() => {
    // window.history.length > 2 means there's a real previous page
    // (1 = new tab, 2 = direct navigation to this page)
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(fallbackRoute, { replace: true });
    }
  }, [navigate, fallbackRoute]);
}
